// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.91 12.3601L17 20.8541L14.182 21.8801L11.09 13.3861L6.918 16.5421L8.408 1.63306L19.134 12.0961L13.91 12.3601Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
